export default __webpack_public_path__ + "static/media/header.a508126f.png";